<div class="form-dialog">
  <h1><span>{{form_title}}</span>
</h1>
<mat-dialog-content>
  <mat-tab-group [disableRipple]="true">
    @if (model.type !== 'group') {
      <mat-tab label="Groups">
        <ng-template matTabContent>
          <relationship-group-selector [model]="model"></relationship-group-selector>
        </ng-template>
      </mat-tab>
    }
    @if (model.type !== 'user') {
      <mat-tab label="Users">
        <ng-template matTabContent>
          <relationship-user-selector [model]="model"></relationship-user-selector>
        </ng-template>
      </mat-tab>
    }
    @if (model.type !== 'session_state') {
      <mat-tab label="Pages">
        <ng-template matTabContent>
          <relationship-page-selector [model]="model"></relationship-page-selector>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>
<div class="action-buttons">
  <button (click)="onCloseClick()" class="btn-close">Close</button>
  <button (click)="save()" class="btn-save" [disabled]="!canSave()">Save</button>
</div>
</div>
